module.exports = __webpack_public_path__ + "01f43047/img/send-icon.3cfb6275.svg";